import { render } from "./BarList.vue?vue&type=template&id=e70bca86&scoped=true"
import script from "./BarList.vue?vue&type=script&lang=js"
export * from "./BarList.vue?vue&type=script&lang=js"

import "./BarList.vue?vue&type=style&index=0&id=e70bca86&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e70bca86"]])

export default __exports__